/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Blog_TitleInputs */

const en_seo_blog_title = /** @type {(inputs: Seo_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog for trainers`)
};

const pl_seo_blog_title = /** @type {(inputs: Seo_Blog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blog dla trenerów`)
};

/**
* | output |
* | --- |
* | "Blog for trainers" |
*
* @param {Seo_Blog_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_blog_title = /** @type {((inputs?: Seo_Blog_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Blog_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_blog_title(inputs)
	return en_seo_blog_title(inputs)
});